import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BuyerOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/signin');
        return;
      }

      const response = await axios.get('/api/offers/buyer/offers?role=buyer', {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('API Response:', response.data);
      
      // Handle response structure - it might be wrapped in data.data
      let ordersData = [];
      if (response.data && response.data.data) {
        ordersData = response.data.data;
      } else if (Array.isArray(response.data)) {
        ordersData = response.data;
      } else if (response.data && response.data.offers) {
        ordersData = response.data.offers;
      }
      
      setOrders(ordersData);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching orders:', err);
      setError('Failed to load orders: ' + (err.response?.data?.error || err.message));
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      'sent': 'bg-gray-500',
      'accepted': 'bg-yellow-500',
      'in_progress': 'bg-blue-500',
      'delivered': 'bg-purple-500',
      'completed': 'bg-green-500'
    };
    return colors[status] || 'bg-gray-500';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-500">Loading orders...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">My Orders</h1>
      
      {orders.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg">
          <p className="text-gray-500">No orders found</p>
          <button 
            onClick={() => navigate('/buyer/dashboard')}
            className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Browse Services
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <div key={order._id} className="border rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-lg font-semibold">{order.title || 'Order'}</h3>
                  <p className="text-gray-600 text-sm mt-1">Offer ID: {order._id?.slice(-8)}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-white text-sm ${getStatusColor(order.status)}`}>
                  {order.status?.replace('_', ' ').toUpperCase()}
                </span>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <p className="text-gray-500 text-sm">Amount</p>
                  <p className="font-semibold">${order.price?.toLocaleString() || '0'}</p>
                </div>
                <div>
                  <p className="text-gray-500 text-sm">Created</p>
                  <p className="text-sm">{new Date(order.createdAt).toLocaleDateString()}</p>
                </div>
              </div>
              
              <button
                onClick={() => navigate(`/buyer/order/${order._id}`)}
                className="mt-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
              >
                View Order Details
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BuyerOrders;
